import * as yup from "yup"
import type { TextContent } from "../../types"

export function initialValuesText(text?: TextContent | undefined) {
  if (text) {
    return text
  }
  return {
    key: "",
    content: "",
  }
}

export function validationSchemaText() {
  return yup.object().shape({
    key: yup.string().required("Campo obbligatorio"),
    content: yup.string().required("Campo obbligatorio"),
  })
}
